import { render } from "./QwoachDrawer.vue?vue&type=template&id=7a0dc8a3"
import script from "./QwoachDrawer.vue?vue&type=script&lang=js"
export * from "./QwoachDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__